<script>
import CalendarEventFormModal from '@app/components/CalendarEventFormModal.vue';
import WhyCalendarEvents from '@app/pages/calendar/WhyCalendarEvents.vue';

export default {
  components: { WhyCalendarEvents },
  data() {
    return {
      calendarEnabled: this.$store.getters['auth/store']?.calendar_options?.enabled || false,
    };
  },
  computed: {
    hasCalendarPlan() {
      return this.$store.getters['auth/hasProPlan'] || this.$store.getters['auth/hasExpertPlan'];
    },
  },
  methods: {
    goPro() {
      this.$showMessage.goPro();
    },
    openCreateModal() {
      if (!this.hasCalendarPlan) {
        this.goPro();
        return;
      }

      this.$buefy.modal.open({
        parent: this,
        component: CalendarEventFormModal,
        hasModalCard: true,
        trapFocus: true,
        events: {
          saved: () => this.$root.$emit('calendar:refresh'),
        },
      });
    },
    async toggleCalendar(value) {
      this.$store.dispatch('auth/updateStore', {
        calendar_options: { enabled: value },
      }).then(() => {
        this.$buefy.toast.open({
          message: value ? 'Calendrier activé' : 'Calendrier désactivé',
          type: 'is-success',
        });
      }).catch(() => {
        this.calendarEnabled = !value;
        this.$buefy.toast.open({
          message: 'Erreur lors de la mise à jour',
          type: 'is-danger',
        });
      });
    },
  },
};
</script>

<template>
  <div class="container">
    <header class="columns is-vcentered">
      <div class="column is-8">
        <h1 class="title is-size-4-mobile">
          Calendrier
        </h1>
        <p class="is-size-8">
          Gérez vos événements (webinaires, sessions en direct, ateliers)
          et communiquez-les à vos apprenants. En plus de ces événements,
          le calendrier de chaque apprenant affiche automatiquement <strong>ses dates
          personnalisées de déblocage des leçons ainsi que les classes virtuelles</strong>
          auxquelles il est inscrit.
        </p>
      </div>
      <div v-if="hasCalendarPlan" class="column is-4">
        <div class="box">
          <div class="is-flex is-align-items-center is-justify-content-space-between">
            <div>
              <p class="has-text-weight-bold is-size-7">
                Afficher le calendrier aux apprenants
              </p>
              <p class="is-size-8 has-text-grey-dark">
                Visible dans leur espace
                <b-tooltip position="is-bottom" multilined>
                  <template #content>
                    En activant cette option, un nouveau menu « Calendrier »
                    apparaît dans l'espace de chaque apprenant, où il retrouve
                    un agenda pédagogique personnalisé.
                  </template>
                  <b-icon icon="question-circle" size="is-small" />
                </b-tooltip>
              </p>
            </div>
            <b-switch
              v-model="calendarEnabled"
              type="is-success"
              @input="toggleCalendar"
            />
          </div>
        </div>
      </div>
    </header>

    <template v-if="hasCalendarPlan">
      <div class="tabs mb-10">
        <ul>
          <router-link
            tag="li"
            :class="{'is-active': $route.name === 'calendar'}"
            :to="{name: 'calendar'}"
          >
            <a>Événements</a>
          </router-link>
          <router-link
            tag="li"
            :class="{'is-active': $route.name === 'calendar_why'}"
            :to="{name: 'calendar_why'}"
          >
            <a>Pourquoi utiliser les événements ?</a>
          </router-link>
        </ul>
      </div>

      <div>
        <router-view @create="openCreateModal" />
      </div>
    </template>

    <template v-else>
      <go-pro-wrapper class="mb-6" />
      <WhyCalendarEvents />
    </template>
  </div>
</template>
